export default {
  header: {
    collection: 'Sammlung',
    discord: 'Discord Beitreten',
    twitter: 'Twitter Folgen',
  },
  landing: {
    discover: 'Entdecke',
    nodeRocks: 'NODE_ROCKS',
    onBitcoin: 'auf Bitcoin',
    searchPlaceholder: 'Rock-ID eingeben...',
    viewDetails: 'Details Anzeigen',
  },
  story: {
    title: 'Die Geschichte Hinter NodeRocks',
    description: 'NodeRocks wurde im Dezember von einem Entwickler namens {{developer}} ins Leben gerufen. Als das Projekt jedoch von einem möglichen Rug Pull bedroht war, weigerte sich die Community, es sterben zu lassen. Stattdessen schlossen sie sich zusammen, übernahmen die Kontrolle und begannen, das Projekt von Grund auf neu aufzubauen.',
    community: 'Die Community erhielt schnell Zugang zum {{platform}} Entwicklerportal und startete neue Social-Media-Kanäle, um sich wieder zu verbinden und zu wachsen. Innerhalb weniger Wochen war NodeRocks stärker als je zuvor, und die Community begann, aufregende Funktionen wie ihre eigene Staking-Plattform, Explorer und sogar Musik für das Projekt zu entwickeln.',
    conclusion: 'NodeRocks ist jetzt das erste zu 100% community-getriebene Projekt im Ordinals-Bereich, ein Beweis für die Kraft einer leidenschaftlichen Gemeinschaft, die sich zusammenschließt, um das Projekt zu neuen Höhen zu führen. Vom Beinahe-Kollaps zu einer florierenden, innovativen Gemeinschaft ist NodeRocks zu einem Symbol für Widerstandsfähigkeit und Kreativität in der Welt der Bitcoin Ordinals geworden.',
  },
  yinYang: {
    title: 'Yin Yang Inschriften',
    subtitle: 'Symbol der Harmonie auf Bitcoin für immer on-chain',
    history: {
      title: 'Geschichte',
      description: 'Unter den Verfluchten Inschriften entstand ein einzigartiges Phänomen, als {{positive}} und {{negative}} Inschriften mit demselben Satoshi verbunden wurden. Diese Paarung symbolisierte Dualität und Harmonie, inspiriert von der alten chinesischen Philosophie des Yin und Yang.',
    },
    rarity: {
      title: 'Wie Selten Sind Yin Yang Inschriften?',
      description: 'Es gibt nur {{count}} Yin Yang Inschriften für immer auf Bitcoin, was sie zu einer unglaublich seltenen Untergruppe der {{total}} Verfluchten Inschriften macht. Ihre Erstellung endete nach dem {{block}} im Jahr 2024, was ihre Seltenheit festigte.',
    },
  },
  cursedRocks: {
    title: 'Die Dualität der Verfluchten Rocks',
    subtitle: 'Ein Einzigartiges Kapitel in Bitcoin Ordinals',
    normal: 'Normal',
    cursed: 'Verflucht',
    hoverReveal: 'Hover für Fluch-Ansicht',
    whatAre: {
      title: 'Verfluchte Rocks?',
      description: 'Jeder NodeRock kommt mit seinem verfluchten Gegenstück, da beide einzigartig auf demselben Satoshi gespeichert sind. Der NodeRock repräsentiert die positive Inschrift, während der Verfluchte Rock als sein negatives Gegenstück dient. Zusammen bilden sie ein perfektes Yin Yang Gleichgewicht, das Dualität und Verbundenheit symbolisiert.',
    },
    rarity: {
      title: 'Seltenheit & Wert',
      description: 'NodeRocks ist die erste Sammlung, die ein Kaufe 1, Erhalte 2 Konzept anbietet, bei dem jeder NodeRock mit seinem gepaarten Verfluchten Rock kommt und ein Yin Yang Gleichgewicht bildet. Mit nur 70.000 jemals erstellten Yin Yang Inschriften wird es nie wieder neue Yin Yang Inschriften geben—was jedes Paar zu einem exklusiven und seltenen Vermögenswert macht.',
    },
  },
  laboratory: {
    title: 'STAKE DEINE NODEROCKS!',
    stakeNow: 'JETZT STAKEN',
  },
  showcase: {
    title: 'Zeige Deinen Rock',
    subtitle: 'Sei Teil der digitalen Kunstrevolution auf Bitcoin',
    viewCollection: 'Komplette Sammlung Ansehen',
  },
  footer: {
    language: 'Sprache',
    selectLanguage: 'Sprache Auswählen',
    links: 'Schnelllinks',
    marketplace: 'Magic Eden Marktplatz',
    discord: 'Discord Beitreten',
    twitter: 'Twitter Folgen',
    community: 'Community',
    rights: 'Alle Rechte vorbehalten.',
  },
};